import { HttpInterceptorFn } from '@angular/common/http';
import { SESSION_STORAGE_KEY } from '../storage/storage.constant';

/**
 * URL segments (partial match) for endpoints that must not receive an Authorization header.
 * Sourced from MYRACE-SUPERAPP Swagger paths verified as reachable without a token.
 */
const PUBLIC_URL_PATTERNS: string[] = [
  // Auth (Login/Registration)
  'auth/login',
  'auth/registration',
  'auth/forgot-user',
  'auth/forgot-password',
  'auth/validate-phone',
  'auth/refresh',
  // Covers otp/public/*, invoice/public/*, file/save/public, terms-and-conditions/public/*
  '/public/',
  // Other public superapp endpoints
  'v1/superapp/application-setting/view-public',
  'v1/superapp/default-password/get-current',
  'v1/superapp/default-password/rules',
  'v1/superapp/home-feature-visibility-configuration',
  'v1/superapp/on-call-registration-number',
  'v1/superapp/app-version-control/check',
  'v1/superapp/referral-code/validate',
  'v1/superapp/terms-and-conditions/public/default',
  'v1/file/view',
];

function isPublicRequest(url: string): boolean {
  return PUBLIC_URL_PATTERNS.some((pattern) => url.includes(pattern));
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem(SESSION_STORAGE_KEY.ACCESS_TOKEN) || null;

  // Allow requests that explicitly opt out via header
  if (req.headers.has('skip-interceptor')) {
    const cloned = req.clone({
      headers: req.headers.delete('skip-interceptor'),
    });
    return next(cloned);
  }

  // Skip token attachment for known public auth endpoints
  if (isPublicRequest(req.url)) {
    const cloned = req.clone({
      setHeaders: {
        Platform: 'WEB_SELF_CARE',
      },
    });
    return next(cloned);
  }

  if (token) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        Platform: 'WEB_SELF_CARE',
      },
    });
    return next(cloned);
  }
  return next(req);
};
